var CustomEvent = require('../constants/customEvent')

module.exports = Em.Object.extend({
    isLoaded: false,

    data: null,

    api: Em.inject.service(),

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    load: function() {
        var self = this
        this.set('isLoaded', false)
        var organization = this.get('organization')
        var url = '/reconciliation/organizations/' + organization.get('id') + '/bank-accounts'

        this._loadPromise = this.get('api').request('GET', url)
            .then(function(response) {
                var bankAccounts = response

                self.set('data', bankAccounts.data)
                self.set('isLoaded', true)
                self._loadPromise = null
                return bankAccounts
            })
        return this._loadPromise
    },

    ensureLoaded: function() {
        if (this.get('isLoaded')) {
            return Em.RSVP.resolve(this.get('data'))
        }
        return this._loadPromise || this.load()
    },

    initEvents: function() {
        var loadFn = this.load.bind(this)
        this.set('loadBound', loadFn)

        window.addEventListener(CustomEvent.BankAccountReconciliationStartDateUpdated, this.get('loadBound'))
    }.on('init'),

    destroyEvents: function() {
        window.removeEventListener(CustomEvent.BankAccountReconciliationStartDateUpdated, this.get('loadBound'))
    }.on('willDestroy')
})
